import { buildInstanceRoutingComposable } from "@/components/ConfigTemplates/routing";
export const useInstanceRouting = buildInstanceRoutingComposable("/file_source_instances/index");
